export default {
  'company introduction': 'company introduction',
}



// WEBPACK FOOTER //
// ./src/comm/i18n/en-us/index.js